import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-depositos-pagamentos',
  templateUrl: './depositos-pagamentos.component.html',
  styleUrls: ['./depositos-pagamentos.component.css']
})
export class DepositosPagamentosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
